module.exports = __webpack_public_path__ + "static/img/challenge_warriors_bg.bd53fcb8.png";